import React from 'react';
import { Triangle as TriangleIcon } from 'lucide-react';

import { cn } from '@epoch-ui/lib/utils';
import { IconProps } from '@epoch-ui/components/Icon';

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

interface SortIndicatorProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    Pick<IconProps, 'size'> {
  sortOrder?: SortOrder | undefined;
}

export const SortIndicator = React.forwardRef<HTMLSpanElement, SortIndicatorProps>(
  ({ sortOrder, size = 8, className, ...props }, ref) => {
    return (
      <span className={cn('tw-flex tw-flex-col', className)} ref={ref} {...props}>
        <TriangleIcon
          fill="currentColor"
          strokeWidth={0}
          size={size}
          className={cn(sortOrder === SortOrder.DESC && 'tw-opacity-0')}
        />
        <TriangleIcon
          fill="currentColor"
          strokeWidth={0}
          size={size}
          className={cn('tw-rotate-180', sortOrder === SortOrder.ASC && 'tw-opacity-0')}
        />
      </span>
    );
  }
);
